import React from 'react';
import { useNavigate } from 'react-router-dom';
import actividadAzul from "../../../static/img/actividadIconAzul.svg";
import actividad from "../../../static/img/actividadIcon.svg";
import entrenamientoIcon from "../../../static/img/entrenamientoIcon.svg";
import enntrenamientoAzul from "../../../static/img/entrenamientoAzul.svg";
import profile from "../../../static/img/profileIcon.svg";
import profileAzul from "../../../static/img/profileAzul.svg"
import searchIcon from "../../../static/img/searchIcon.svg";
import searchIconAzul from "../../../static/img/searchIconAzul.svg";
import './styles.css';

const Footer = ({ activeScreen }) => {
  const navigate = useNavigate();

  return (
    <div className="footer-container">
      <button
        className={`footer-item ${activeScreen === 'actividad' ? 'active-button' : ''}`}
        aria-label="Ver Actividad"
        onClick={() => navigate('/dashboard')}
      >
        <img src={activeScreen === 'actividad' ? actividadAzul : actividad} alt="Actividad" className="footer-icon" />
        <span className={`footer-text ${activeScreen === 'actividad' ? 'active-text' : ''}`}>Actividad</span>
      </button>

      <button
        className={`footer-item ${activeScreen === 'entrenadores' ? 'active-button' : ''}`}
        aria-label="Buscar Entrenadores"
        onClick={() => navigate('/entrenadores')}
      >
        <img src={activeScreen === 'entrenadores' ? searchIconAzul : searchIcon} alt="Entrenadores" className="footer-icon" />
        <span className={`footer-text ${activeScreen === 'entrenadores' ? 'active-text' : ''}`}>Entrenadores</span>
      </button>

      <button
        className={`footer-item ${activeScreen === 'entrenamiento' ? 'active-button' : ''}`}
        aria-label="Ver Entrenamiento"
        onClick={() => navigate('/entrenamiento')}
      >
        <img src={activeScreen === 'entrenamiento' ? enntrenamientoAzul : entrenamientoIcon} alt="Entrenamiento" className="footer-icon" />
        <span className={`footer-text ${activeScreen === 'entrenamiento' ? 'active-text' : ''}`}>Entrenamiento</span>
      </button>

      <button
        className={`footer-item ${activeScreen === 'perfil' ? 'active-button' : ''}`}
        aria-label="Ver Perfil"
        onClick={() => navigate('/perfil')}
      >
        <img src={activeScreen === 'perfil' ? profileAzul : profile} alt="Perfil" className="footer-icon" />
        <span className={`footer-text ${activeScreen === 'perfil' ? 'active-text' : ''}`}>Perfil</span>
      </button>
    </div>
  );
};

export default Footer;
